let development_mode = 1


export let BASE_URL = "https://api.elitesoccer18.com/";
export let BASE_URL_IMG: string = "https://img.elitesoccer18.com/";

if (development_mode === 2) {
    BASE_URL_IMG = "http://192.168.1.46/img.elitesoccer18/"
    BASE_URL = "http:///192.168.1.46/elitesports17-ess18/"
}